import { Calendar } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { addHours } from "date-fns";

import { SecretaryLayout } from "../Layout";
import { localizer, getMessages } from "../../helpers";

const events = [
  {
    title: "Cita agendada",
    notes: "Hay que celebrarlo",
    start: new Date(),
    end: addHours(new Date(), 2),
    bgColor: "#ff0000",
    user: {
      id: 1,
      name: "Germán",
    },
  },
];

export const CalendarPage = () => {
  const eventStyleGetter = (event, start, end, isSelected) => {
    console.log({ event, start, end, isSelected });
  };

  return (
    <SecretaryLayout className="container-fluid">
      <div className="layout-specing">
        <h5 className="mb-0">Calendario</h5>
        <div className="row">
          <div className="col-12 mt-4">
            <Calendar
              culture="es"
              localizer={localizer}
              events={events}
              startAccessor="start"
              endAccessor="end"
              style={{ height: "calc( 100vh - 200px )" }}
              messages={getMessages()}
              eventPropGetter={eventStyleGetter}
            />
          </div>
        </div>
      </div>
    </SecretaryLayout>
  );
};
